
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';

@Component({
	name: "EditarHistorialModal",
})

export default class EditarHistorialModal extends Vue {
	@Prop() historial_selected!: any
	@Prop() swModal!: boolean;
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	public dialog = false;
	$refs!: {
		form: HTMLFormElement,
	};

	historial = {
		id: null,
		motivo: '',
		historia_enfermedad_actual: '',
		antecedentes_personales_patologicos: '',
		gestaciones: '',
		partos: '',
		abortos: '',
		cesareas: '',
		fecha_ultima_menstruacion: '',
		oroscopia: '',
		rinoscopia: '',
		otoscopia: '',
		examenes_complementarios: '',
		diagnostico: '',
		nota: '',
		tratamiento: '',
		consulta_id: null
	}
	valid = true;

	mounted() {
		this.cargarDatos();
		this.dialog = this.swModal
	}

	close() {
		this.$emit('close')
	}

	registrarPago() {
		if (!this.$refs.form.validate()) {
			Alert.warning(`Lene todos los campos obligatorios (*)`)
			return;
		}

		Alert.confirm(`Se realizará el la modificacion del historial`, 'Modificar historial?').then(async result => {
			if (result.isConfirmed) {
				await this.consultorioService.updateHistorial(this.historial)
				this.limpiar()
				this.$emit('close')
				this.$emit('actualizar')
			}
		})


	}

	cargarDatos() {

		this.historial.id = this.historial_selected.id;
		this.historial.motivo = this.historial_selected.consulta?.motivo;
		this.historial.historia_enfermedad_actual = this.historial_selected.historia_enfermedad_actual;
		this.historial.antecedentes_personales_patologicos = this.historial_selected.antecedentes_personales_patologicos;
		this.historial.gestaciones = this.historial_selected.gestaciones;
		this.historial.partos = this.historial_selected.partos;
		this.historial.abortos = this.historial_selected.abortos;
		this.historial.cesareas = this.historial_selected.cesareas;
		this.historial.fecha_ultima_menstruacion = this.historial_selected.fecha_ultima_menstruacion;
		this.historial.oroscopia = this.historial_selected.oroscopia;
		this.historial.rinoscopia = this.historial_selected.rinoscopia;
		this.historial.otoscopia = this.historial_selected.otoscopia;
		this.historial.examenes_complementarios = this.historial_selected.examenes_complementarios;
		this.historial.diagnostico = this.historial_selected.diagnostico;
		this.historial.nota = this.historial_selected.nota;
		this.historial.consulta_id = this.historial_selected.consulta_id
		this.historial.tratamiento = this.historial_selected.tratamiento
	}


	limpiar() {
		this.historial = {
			id: null,
			motivo: '',
			historia_enfermedad_actual: '',
			antecedentes_personales_patologicos: '',
			gestaciones: '',
			partos: '',
			abortos: '',
			cesareas: '',
			fecha_ultima_menstruacion: '',
			oroscopia: '',
			rinoscopia: '',
			otoscopia: '',
			examenes_complementarios: '',
			diagnostico: '',
			nota: '',
			tratamiento: '',
			consulta_id: null
		}

	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get pacientes(): any {
		return this.consultorioStore.pacientes;
	}

}

